'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n'], ['\n  width: 100%;\n  display: flex;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _MozartNavigationItem = require('./MozartNavigationItem');

var _MozartNavigationItem2 = _interopRequireDefault(_MozartNavigationItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var getNavigationItems = function getNavigationItems(items) {
  var DATA = [];

  items.forEach(function (item, index) {
    DATA.push(_react2.default.createElement(_MozartNavigationItem2.default, {
      key: index,
      data: item.data,
      items: item.items,
      style: item.style,
      onClick: item.onClick
    }));
  });

  return DATA;
};

var MozartNavigation = function MozartNavigation(props) {
  var style = props.style,
      data = props.data,
      themeId = props.themeId;

  return _react2.default.createElement(
    Container,
    { style: style, 'data-qa': props.testId, 'data-theme': themeId },
    getNavigationItems(data)
  );
};

MozartNavigation.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** override style */
  style: _propTypes2.default.object,
  /** array of navigation items object {data: label of navigation item, items: array of dropdown items objects {itemData: , itemValue: }} */
  data: _propTypes2.default.array.isRequired
};

MozartNavigation.defaultProps = {
  testId: 'MozartNavigation',
  themeId: 'MozartNavigation'
};

exports.default = MozartNavigation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartNavigation/MozartNavigation.js
// module id = 1836
// module chunks = 1